// store/thunks/auth/verify2faCodeThunk.ts
import { MIN_LEN } from '@/constants';
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import type { FinalizeVerifyDTO } from '@/types/auth/AuthDTOs';
import { setSessionToken, setRefreshToken } from '@/utils/sessionStorage';

import { withErrorHandling, withLoader } from '../thunkWrappers';

export const verify2faCodeThunk = createAppAsyncThunk<
  FinalizeVerifyDTO,
  { code: string },
  { rejectValue: { message: string } }
>('auth/verify2faCode',  withErrorHandling(
    withLoader(
 async({ code }, { getState, extra: { authService }, rejectWithValue }) => {
  const state = getState();
  const twoFactorToken = state.auth.twoFactorToken;

  if (twoFactorToken === undefined || twoFactorToken.trim().length === MIN_LEN) {
    return rejectWithValue({ message: 'Missing two-factor token' });
  }

  try {
    const result = await authService.verifyTwoFactorCode({
      code,
      twoFactorToken,
    });
    setSessionToken(result.sessionToken);
    setRefreshToken(result.refreshToken);
    return result;
  } catch (caught) {
    const message = caught instanceof Error ? caught.message : 'Failed to verify 2FA code';
    return rejectWithValue({ message });
  }
})));
